export default __webpack_public_path__ + "static/media/secure.dea5000b.svg";